import type { EnhancedManCodeId, EnhancedProductFamilyId, EnhancedProductGroupId } from '#api/enhancements/enhancedTmsApiTypes'
import { isStoredUserData, type StoredUserData, type UserDataVersion } from '#features/UserData/StoredUserData'
import type { TruckConfiguration } from '#store/slices/configurationSlice'

export type FavoriteEntry_0_1_0 = (EnhancedProductFamilyId | EnhancedProductGroupId)[]

export interface FavoritesData_0_1_0 {
  favorites: FavoriteEntry_0_1_0
}

export interface RecentManCodesData_0_1_0 {
  manCodes: {
    manCode: EnhancedManCodeId
    partPeriod?: TruckConfiguration['apiConfiguration']['partPeriod']
    deliveryDate?: TruckConfiguration['apiConfiguration']['desiredDealerDate']
    timestamp: Timestamp
    marketDenomination?: TruckConfiguration['marketDenomination']
    title?: TruckConfiguration['title']
  }[]
}

export interface UserData_0_1_0 {
  favorites: FavoritesData_0_1_0
  recentManCodes: RecentManCodesData_0_1_0
}

export const userDataVersionNumber_0_1_0 = 'v0.1.0' as UserDataVersion
export type StoredUserData_0_1_0 = StoredUserData<UserData_0_1_0, typeof userDataVersionNumber_0_1_0>

export function isStoredUserData_0_1_0(storedData: unknown): storedData is StoredUserData_0_1_0 {
  return isStoredUserData(storedData) && storedData.__version === userDataVersionNumber_0_1_0
}
